<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div id="topo" class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title"
                  >{{notaTomador ? 'Emissão das Notas Fiscais de Serviço Tomador.' : 'Emissão dos Documentos Auxiliares de Prestação de Serviço (DAPS).'}}</span>
                <br />
                <span class="navigation">{{notaTomador ? 'Nota Tomador > Emissão' : 'DAPS > Emissão'}}</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <error-list :erros="erros" />
          <tomador-cadastro :tipoEmissao="selectedTipoEmissao.key" v-if="selectedTipoEmissao"/>
          <remover-tomador :tipoEmissao="selectedTipoEmissao.key" v-if="selectedTipoEmissao"/>

          <div class="row d-flex align-items-end">
            <div class="col-md-2 mb-2">
              <label for="tipoEmissao">Tipo Emissão:</label>
              <span class="p-fluid">
                <Dropdown
                  id="tipoEmissao"
                  name="tipoEmissao"
                  v-model="selectedTipoEmissao"
                  :options="tiposEmissao"
                  optionLabel="name"
                  placeholder="Selecione um Tipo"
                  @change="selecionarTipoEmissao()"
                />
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <label for="tipoTomador"
                >Tipo
                {{
                  selectedTipoEmissao && selectedTipoEmissao.key == "T" ? "Prestador" : "Tomador"
                }}:</label
              >
              <span class="p-fluid">
                <Dropdown
                  @change="selectedPessoa = null, validarTipoTomador();"
                  id="tipoTomador"
                  v-model="selectedTipoTomador"
                  :options="tiposTomador"
                  optionLabel="name"
                  placeholder="Selecione um Tipo de Tomador"
                />
              </span>
            </div>
            <div class="col-md-5 mb-2">
              <label for="tomador">{{ selectedTipoTomador.name }}</label>
              <span class="p-fluid">
                <AutoComplete
                  id="tomador"
                  v-model="selectedPessoa"
                  :dropdown="true"
                  :suggestions="filteredPessoas"
                  @complete="searchPessoa($event)"
                  @item-select="atualizarDadosPessoaSelecionada()"
                  field="detail"
                  :placeholder="
                    selectedTipoTomador.key == 'N'
                      ? 'Não Identificado'
                      : 'Pesquisar'
                  "
                  :disabled="selectedTipoTomador.key == 'N'"
                >
                  <template #item="slotProps">
                    <div class="p-fluid" style="max-width: 50vw">
                      {{ slotProps.item.detail }}
                    </div>
                  </template>
                </AutoComplete>
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <span class="p-fluid ml-2">
                <div class="p-inputgroup">
                  <Button
                    @click="novoTomador()"
                    id="btnNovoTomador"
                    type="button"
                    icon="pi pi-plus"
                    :title="
                      'Cadastrar ' +
                      (selectedTipoEmissao && selectedTipoEmissao.key == 'P' ? 'Tomador' : 'Prestador')
                    "
                    :disabled="desabilitarBotaoNovoTomador"
                  />
                  <Button
                    @click="editarTomador()"
                    id="btnEditarTomador"
                    type="button"
                    icon="pi pi-pencil"
                    :title="
                      'Editar ' +
                      (selectedTipoEmissao && selectedTipoEmissao.key == 'P' ? 'Tomador' : 'Prestador')
                    "
                    :disabled="desabilitarBotaoEdicaoTomador"
                  />
                  <Button
                    @click="removerTomador()"
                    id="btnRemoverTomador"
                    type="button"
                    icon="pi pi-trash"
                    :title="
                      'Remover ' +
                      (selectedTipoEmissao && selectedTipoEmissao.key == 'P' ? 'Tomador' : 'Prestador')
                    "
                    :disabled="desabilitarBotaoRemoverTomador"
                  />
                </div>
              </span>
            </div>
          </div>

          <detalhes-contribuinte :tipoEmissao="selectedTipoEmissao.key" v-if="selectedTipoEmissao"/>

          <div class="row">
            <div class="col-md-2 mb-2">
              <label for="dataEmissao">Data Fato Gerador:</label>
              <span class="p-fluid">
                <Calendar
                  id="dataEmissao"
                  name="dataEmissao"
                  v-model="daps.dataFatoGerador"
                  :showIcon="true"
                  dateFormat="dd/mm/yy"
                  @date-select="emissaoSelect()"
                />
              </span>
            </div>
            <div class="col-md-8 mb-2">
              <label for="servico">Serviço:</label>
              <span class="p-fluid">
                <AutoComplete
                  id="servico"
                  v-model="selectedServico"
                  :dropdown="true"
                  :suggestions="filteredServicos"
                  @complete="searchServico($event)"
                  @item-select="zerarValores()"
                  field="detail"
                  placeholder="Pesquisar"
                >
                  <template #item="slotProps">
                    <div class="p-fluid" style="max-width: 50vw">
                      {{ slotProps.item.detail }}
                    </div>
                  </template>
                </AutoComplete>
              </span>
            </div>
          </div>

          <div class="row d-flex align-items-end">
            <div class="col-md-3 mb-2">
              <label for="tipoRec">Tipo Recolhimento:</label>
              <span class="p-fluid">
                <Dropdown
                  id="tipoRec"
                  name="tipoRec"
                  v-model="selectedTipoRecolhimento"
                  :options="tiposRecolhimento"
                  optionLabel="name"
                  placeholder="Selecione um Tipo de Recolhimento"
                  @change="validarTela()"
                />
              </span>
            </div>
            <div class="col-md-3 mb-2">
              <label for="regimeTrib">Regime de Tributação:</label>
              <span class="p-fluid">
                <Dropdown
                  id="regimeTrib"
                  name="regimeTrib"
                  v-model="selectedRegimeTributacao"
                  :options="regimesTributacao"
                  optionLabel="name"
                  placeholder="Selecione um Regime de Tributação"
                  @change="zerarValores()"
                />
              </span>
            </div>
          </div>

          <div class="row d-flex align-items-end">
            <div class="col-md-6 mb-2">
              <label for="munic">Município Prestação</label>
              <span class="p-fluid">
                <AutoComplete
                  id="munic"
                  v-model="selectedMunicPrestacao"
                  :dropdown="true"
                  :suggestions="filteredLocalidades"
                  @complete="searchLocalidade($event)"
                  @item-select="validarLocalidadeSelecionada()"
                  field="detail"
                  placeholder="Pesquisar"
                  :disabled="desabilitarEdicaoMunicipioPrestacao"
                />
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <label for="tipoNota">Tipo da Nota:</label>
              <span class="p-fluid">
                <Dropdown
                  id="tipoNota"
                  name="tipoNota"
                  v-model="selectedTipoNota"
                  :options="tiposNota"
                  optionLabel="name"
                  :disabled="desabilitarCampoTipoNota"
                  placeholder="Selecione um Tipo de Nota"
                />
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <label for="numeroNota">Número da Nota:</label>
              <span class="p-fluid">
                <InputText
                  v-model="daps.numeroNota"
                  type="text"
                  style="text-align: right"
                ></InputText>
              </span>
            </div>
          </div>

          <div class="row d-flex align-items-end">
            <div class="col-md-2 mb-2">
              <label for="valorServico">Valor Serviço:</label>
              <span class="p-fluid">
                <money
                  id="numeroNota"
                  name="numeroNota"
                  v-model="daps.valorServico"
                  v-bind="money"
                  class="p-inputtext input-right"
                  @blur.native="validarDescontoAutomatico()"
                ></money>
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <label for="aliquota">Alíquota:</label>
              <span class="p-fluid">
                <money
                  id="aliquota"
                  name="aliquota"
                  v-model="daps.aliquota"
                  v-bind="percent5"
                  @blur.native="validarAliquota()"
                  :disabled="desabilitarCampoAliquota"
                  class="p-inputtext input-right"
                ></money>
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <label for="deducao">Dedução:</label>
              <span class="p-fluid">
                <money
                  id="deducao"
                  name="deducao"
                  v-model="daps.valorDesconto"
                  v-bind="money"
                  :disabled="desabilitarCampoDeducao"
                  class="p-inputtext input-right"
                ></money>
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <label for="baseCalculo">Base de cálculo:</label>
              <span class="p-fluid">
                <money
                  id="baseCalculo"
                  v-model="baseCalculo"
                  name="baseCalculo"
                  v-bind="money"
                  class="p-inputtext input-right"
                  disabled
                ></money>
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <label for="retencaoIss">Valor da retenção:</label>
              <span class="p-fluid">
                <money
                  id="retencaoIss"
                  name="retencaoIss"
                  :value="valorIssFinal"
                  v-bind="money"
                  class="p-inputtext input-right"
                  disabled
                ></money>
              </span>

              <small v-if="isCompensacaoIssAtiva  && ajusteIss !== 'NORMAL'" style="color: #f39c12;">
                Valor ajustado manualmente em {{ ajusteIss === 'MAIS' ? '+R$0,01' : '-R$0,01' }}
              </small>
            </div>

            
          </div>

          <div class="row" v-if="isCompensacaoIssAtiva && valorIssFinal > 0">
            <div class="col-md-5 offset-md-5">
              <div class="d-flex gap-2 mt-1 justify-content-end">
                
                <Button
                  label="+ R$ 0,01"
                  icon="pi pi-arrow-up"
                  class="iss-original p-button-sm p-button-success"
                  @click="aumentarIss"
                  :disabled="ajusteIss === 'MAIS'"
                />

                <Button
                  label="- R$ 0,01"
                  icon="pi pi-arrow-down"
                  class="iss-original p-button-sm p-button-danger"
                  @click="diminuirIss"
                  :disabled="ajusteIss === 'MENOS'"
                />

                <Button
                  label="Valor Original"
                  icon="pi pi-refresh"
                  class="iss-original p-button-sm p-button-secondary"
                  @click="resetarIss"
                  :disabled="ajusteIss === 'NORMAL'"
                />

              </div>
            </div>
          </div>

          <div class="row d-flex align-items-end">
            <div class="col-md-6 mb-2">
              <label for="numeroNota">Chave de validação origem:</label>
              <span class="p-fluid">
                <InputText
                  v-model="daps.codigoVerificacaoOrigem"
                  type="text"
                  class="alinhar-texto"
                  maxlength="60"
                ></InputText>
              </span>
            </div>
          </div>

          <div class="row">
            <div class="col-md-10 mb-2">
              <label for="descServico">Discriminação dos Serviços:</label>
              <span class="p-fluid">
                <textarea
                  id="descServico"
                  name="descServico"
                  v-model="daps.discriminacaoServico"
                  rows="5"
                  style="width: 100%"
                />
              </span>
            </div>
          </div>
          <div class="row d-flex align-items-end">
            <div class="col-md-2 mb-2">
              <label for="valorInss">Inss:</label>
                <span class="p-fluid">
                  <money
                    id="valorInss"
                    name="valorInss"
                    v-model="daps.valorInss"
                    v-bind="money"
                    class="p-inputtext input-right"
                  ></money>
                </span>
              </div>
              <div class="col-md-2 mb-2">
                <label for="valorIr">Ir:</label>
                  <span class="p-fluid">
                    <money
                      id="valorIr"
                      name="valorIr"
                      v-model="daps.valorIr"
                      v-bind="money"
                      class="p-inputtext input-right"
                    ></money>
                  </span>
               </div>
               <div class="col-md-2 mb-2">
                <label for="valorCsll">Csll:</label>
                  <span class="p-fluid">
                    <money
                      id="valorCsll"
                      name="valorCsll"
                      v-model="daps.valorCsll"
                      v-bind="money"
                      class="p-inputtext input-right"
                    ></money>
                  </span>
               </div>
               <div class="col-md-2 mb-2">
                <label for="valorPis">Pis:</label>
                  <span class="p-fluid">
                    <money
                      id="valorPis"
                      name="valorPis"
                      v-model="daps.valorPis"
                      v-bind="money"
                      class="p-inputtext input-right"
                    ></money>
                  </span>
               </div>
               <div class="col-md-2 mb-2">
                <label for="valorCofins">Cofins:</label>
                  <span class="p-fluid">
                    <money
                      id="valorCofins"
                      name="valorCofins"
                      v-model="daps.valorCofins"
                      v-bind="money"
                      class="p-inputtext input-right"
                    ></money>
                  </span>
               </div>
            </div>
            <div class="row">
          <div class="col-md-10 mb-2">
            <label v-if="showMessageSimoes" for="file">Anexar abaixo a Nota Fiscal: </label>
            <label v-else for="file">Selecionar abaixo um arquivo, caso queira anexar ao registro: </label>
            <br/>
            <span class="p-fluid">
              <input type="file" id="files" ref="files" v-on:change="handleFileUploads()" />
            </span>
          </div>
        </div>
          

          <hr />

          <Button
            @click="onSubmit()"
            label="Gravar"
            type="button"
            class="p-button-primary mr-2 p-button-success"
            icon="pi pi-check"
            v-show="exibirBotao.gravar"
            :disabled="loading || inativo"
          />

          <Button
            @click="novoDaps()"
            label="Novo"
            type="button"
            class="p-button-primary mr-2"
            icon="pi pi-plus"
            v-show="exibirBotao.novo"
            :disabled="loading || inativo"
          />

          <Button
            label="Cancelar"
            @click="cancelarDaps()"
            type="button"
            class="p-button-primary mr-2 p-button-danger"
            icon="pi pi-times"
            v-show="exibirBotao.cancelar"
            :disabled="loading || inativo"
          />

          <Button
            @click="imprimirDaps()"
            label="Imprimir"
            type="button"
            class="p-button-primary mr-2"
            icon="pi pi-print"
            v-show="exibirBotao.imprimir"
            :disabled="loading || inativo"
          />
          <!--
          -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import TomadorCadastro from "../views/TomadorCadastro";
import RemoverTomador from "../components/emissaoNfse/RemoverTomador";
import DetalhesContribuinte from "../components/emissaoNfse/DetalhesContribuinte";
import NfsPessoaService from "../services/nfse/pessoa.service";
import DapsService from "../services/nfse/daps.service";
import ServicoService from "../services/tributario/servicos.service";
import LocalidadeService from "../services/acesso/localidade.service";
import LoginService from "../services/acesso/login.service";
import Daps from "../models/nfse/Daps";
import money from "../conf/config.money";
import percent5 from "../conf/config.percent5";
import ReportService from "../services/report.service";
import moment from "moment";
import Util from "../Utils/util";

export default {
  props: {
    notaTomador: Boolean
  },
  name: "emissaoDaps",

  components: {
    TomadorCadastro,
    RemoverTomador,
    DetalhesContribuinte,
  },

  data() {
    return {
      money: money,
      moment: moment,
      percent5: percent5,
      inativo: false,
      daps: new Daps(),
      loading: false,
      currentUser: null,
      selectedTipoTomador: null,
      selectedPessoa: null,
      selectedServico: null,
      filteredPessoas: null,
      filteredServicos: null,
      filteredLocalidades: null,
      selectedTipoRecolhimento: null,
      selectedMunicPrestacao: null,
      selectedRegimeTributacao: null,
      selectedTipoNota: null,
      selectedTipoEmissao: null,
      valorBaseCalculo: 0,
      valorRetencao: 0,
      desabilitarAliquota: false,
      desabilitarDeducao: false,
      refazerDaps: false,
      erros: [],
      files: "",
      showMessageSimoes: false,
      contribuinteCadastro: null,
      tiposTomador: [
        { name: "CPF/CNPJ/Nome", key: "C" },
        //{ name: "Exterior", key: "E" },
      ],
      tiposRecolhimento: [{ name: "Recolhimento na Sede", key: "R" }],
      locaisPrestacao: [
        { name: "Município", key: "M" },
        { name: "Fora do Município", key: "F" },
      ],
      regimesTributacao: [
        { name: "Normal", key: "N" },
        { name: "Simples Nacional", key: "S" },
        { name: "Microempreendedor - MEI", key: "M" },
      ],
      tiposNota: [
        { name: "Normal", key: "N" },
        { name: "Eletrônica", key: "E" },
        { name: "RPA", key: "R" },
      ],
      tiposEmissao: [{ name: "Tomador", key: "T" }],
      codigoIbgePrincipal: null,
      percBeneficioBaseCalculo: null,
      aplicarDeducaoAutomatica: 'N',
      valorIssOriginal: 0,
      ajusteIss: 'NORMAL'
    };
  },

  mounted() {
    document.getElementById("tomador").focus();
  },

  created() {
    //Carrega os Dados da daps
    this.id = this.$route.params.idDaps;
    if(this.id != null){
      setTimeout(async() => {
        await DapsService.getDapsId(this.id).then(
          response =>{
            this.daps = response.data;
            this.refazerDaps = true;
            this.daps.id = null;
            if (this.selectedTipoEmissao && this.selectedTipoEmissao.key == "T") {
              if (this.daps.idPrestadorDados) {
                // Prestador
                this.selectedPessoa = this.daps.prestadorDados;
              }
              if (this.currentUser && this.currentUser.contribuinte) {
                // Tomador
                this.currentUser.contribuinte.idNfsPessoa = this.daps.idTomadorDados;
                this.currentUser.contribuinte.idContribuinte = this.daps.idCntTomador;
              }
            } else {
              if (this.daps.idTomadorDados) {
                // Tomador
                this.selectedPessoa.idContribuinte = this.daps.cntTomador;
                this.selectedPessoa = this.daps.tomadorDados;
              }
              if (this.currentUser && this.currentUser.contribuinte) {
                // Prestador
                this.currentUser.contribuinte.idNfsPessoa = this.daps.idPrestadorDados;
              }
            }
            
            if(this.daps.idServicoItem){
              this.selectedServico = this.daps.servicoItem.idServico;
              this.selectedServico.idServicoItem = this.daps.servicoItem.id;
            }
            this.selectedRegimeTributacao = this.regimesTributacao.filter(
              (local) => local.key == this.daps.idRegimeTributacao
            )[0];
            this.daps.motivoRecusaDaps = null;
          },
          error =>{
            let errorMessage = "Houve um error ao buscar os dados do daps!";
            if(error.response){
              errorMessage = error.response.data;
            }
            this.$taost.add({
              severity: "error",
              summary: errorMessage
            })
          }
        )
      },250)
    }


    this.currentUser = LoginService.currentUserValue;
    this.inativo =
      this.currentUser && this.currentUser.contribuinte
        ? !this.currentUser.contribuinte.ativo
        : false;
    this.limparDadosDaps();
    if (this.currentUser.configuracao.idBolTomadorNaoInformado == "S" && this.currentUser.contribuinteConfig.idBolTomadorNaoInformado != 'N'){
      this.tiposTomador.push({ name: "Não Identificado", key: "N" });
    } else if(this.currentUser.contribuinteConfig.idBolTomadorNaoInformado === 'S'){
      this.tiposTomador.push({ name: "Não Identificado", key: "N" });
    }

    if (this.currentUser.contribuinteConfig.idBolTomadorExterior === 'S'){
      this.tiposTomador.push({ name: "Exterior", key: "E" });
    }

    this.openMessageSimoes();

    this.codigoIbgePrincipal = this.currentUser.configuracao.codigoIbgeCliente;
  },

  methods: {
    emissaoSelect(){
      let dateSelect = this.daps.dataFatoGerador;
      dateSelect.setHours(8);
      this.daps.dataFatoGerador = dateSelect;
      this.clearServico();
    },
    clearServico() {
      this.selectedServico = null;
      this.daps.aliquota = 0;
    },
    limparDadosDaps() {
      this.files = "",
      this.daps = new Daps();

      this.daps.idCliente = this.currentUser.usuario.idCliente; // this.usuario.idCliente;
      this.daps.idUsuario = this.currentUser.usuario.idUsuario; // this.usuario.idConta;


      this.selectedTipoTomador = this.tiposTomador[0];
      this.selectedTipoRecolhimento = this.tiposRecolhimento[0];
      this.selectedTipoNota = this.tiposNota[0];
      
      this.selectedMunicPrestacao = null;
      this.daps.dataFatoGerador = new Date(); // Quando a nota foi emitida realmente

      this.selectedServico = null;
      this.selectedPessoa = "";

      this.daps.discriminacaoServico = "";

      this.validarTela();
    },

    zerarValores() {
      this.ajusteIss = 'NORMAL';
      this.daps.valorServico = 0;
      this.daps.valorDesconto = 0;
      this.validarTela();
    },

    searchPessoa(event) {
      setTimeout(async () => {
        this.filteredPessoas =
          await NfsPessoaService.findAllByConttribuinteFiltroDaps(
            event.query,
            this.selectedTipoTomador.key,
            this.selectedTipoEmissao ? this.selectedTipoEmissao.key : ''
          );
      }, 250);
    },

    searchServico(event) {
      if (this.daps.dataFatoGerador) {
        this.processando(true);
        let dataEmissao = this.moment(this.daps.dataFatoGerador).format(
          "YYYY-MM-DD"
        );
        let filtro = event.query + "*;" + dataEmissao;
        setTimeout(async () => {
          this.filteredServicos = await ServicoService.findAllByClienteFiltro(
            filtro,
            this.currentUser.usuario.idCliente
          );
          this.processando(false);
        }, 250);
      }
    },

    searchLocalidade(event) {
      console.log(this.selectedTipoRecolhimento.key );
      setTimeout(async () => {
        
          this.filteredLocalidades = await LocalidadeService.findAllByFiltroIbge(
            event.query
          );
        
      }, 250);
    },
    handleFileUploads() {
      this.files = this.$refs.files.files;
    },    
    onSubmit() {
      this.$validate().then((success) => {
        if (success) {
          this.salvar();
        }
      });
    },

    salvar() {
      if (this.files && this.files[0]) {
        var fileSize = this.files[0].size / 1024 / 1024; // in MB
        if (fileSize > 20) {
          this.$root.$emit(
            "alert:warn",
            "Este arquivo ultrapassa o limite de 20 MB!"
          );
          return;
        } 
        this.processando(true);
        this.getBase64(this.files[0]).then(response => {

          let base64 = response.replace("data:", "").replace(/^.+,/, "");
          this.daps.file = base64;

          this.daps.nomeArquivo = this.files[0].name;
          this.daps.tipoArquivo = this.files[0].type;

          this.saveDaps();
        });
      }else{
        this.saveDaps();
      }
    },

    saveDaps(){
      if(!this.selectedTipoEmissao || !this.selectedTipoEmissao.key){
          this.$root.$emit(
              "alert:warn",
              "É obrigatório o preenchimento do campo tipo emissão!"
            );
          return;
      }
      if(!this.selectedMunicPrestacao || this.selectedMunicPrestacao == null){
          this.$root.$emit(
              "alert:warn",
              "É obrigatório o preenchimento do campo Município Prestação!"
            );
          return;
      }
      this.processando(true);
      console.log("SALVANDO!!");
      this.daps.idContrEmissor = this.currentUser.contribuinte.idContribuinte; 
      this.daps.tipoTomador = this.selectedTipoTomador.key;
      this.daps.codigoVerificacaoOrigem = Util.removerEspacos(this.daps.codigoVerificacaoOrigem);
      if (this.selectedTipoEmissao && this.selectedTipoEmissao.key == "T") {
        if (this.selectedPessoa) {
          // Prestador
          this.daps.idPrestadorDados = this.selectedPessoa.id;
        }
        if (this.currentUser && this.currentUser.contribuinte) {
          // Tomador
          
          this.daps.idTomadorDados = this.currentUser.contribuinte.idNfsPessoa; // this.usuario.idPrestadorDados;
          this.daps.idCntTomador = this.currentUser.contribuinte.idContribuinte; // this.usuario.idContribuinte;
          
        }
      } // Dependendo do tipo de Emissão os papeis do prestador e do tomador se invertem
      else {
        if (this.selectedPessoa) {
          // Tomador
          this.daps.idCntTomador = this.selectedPessoa.idContribuinte;
          this.daps.idTomadorDados = this.selectedPessoa.id;
        }
        if (this.currentUser && this.currentUser.contribuinte) {
          // Prestador
          this.daps.idPrestadorDados =
            this.currentUser.contribuinte.idNfsPessoa; // this.usuario.idPrestadorDados;
        }
      }

      if (this.selectedServico) {
        this.daps.idServicoItem = this.selectedServico.idServicoItem;
      }
      if (this.selectedTipoRecolhimento) {
        this.daps.tipoRecolhimento = this.selectedTipoRecolhimento.key;
      }
      if (this.selectedRegimeTributacao) {
        this.daps.idRegimeTributacao = this.selectedRegimeTributacao.key;
      }
      if (this.selectedTipoNota) {
        this.daps.tipoNfse = this.selectedTipoNota.key;
      }
      if (this.selectedMunicPrestacao) {
        this.daps.idMunicPrestacao = this.selectedMunicPrestacao.id;
      }
      if (this.selectedTipoEmissao) {
        this.daps.origem = this.selectedTipoEmissao.key;
      }
      //this.daps.dataEmissao = new Date(); // Quando a nota foi persistida no banco preenche no servidor
      //this.daps.dataFatoGerador = new Date(); // Quando a nota foi emitida
      
      if(this.refazerDaps == false){
        this.daps.ano = this.daps.dataFatoGerador.getFullYear();
        this.daps.mes = this.daps.dataFatoGerador.getMonth() + 1; // O getMonth busca valor de 0 a 11
      }
      
      this.daps.valorBaseCalculo = this.baseCalculo;
      
      this.daps.valorIss = this.valorIssFinal;

      if (this.ajusteIss !== 'NORMAL') {
        this.daps.valorIssOriginal = this.valorIss;
      } else {
        this.daps.valorIssOriginal = null;
      }
      
      
      console.log("SALVANDO");
      this.erros = [];
      DapsService.salvar(this.daps)
        .then(
          (data) => {
            this.daps = data.data;

            this.$toast.add({
              severity: "success",
              summary: "Sucesso",
              detail: (this.notaTomador ? "Nota Tomador salva com sucesso!" : "O DAPS foi salvo!"),
              life: 4000,
            });
            this.processando(false);
            this.refazerDaps = false;
            console.log(this.refazerDaps);
          },
          (error) => {
            console.log(error.response);
            
            let errorMessage = this.notaTomador 
              ? "Houve um problema ao salvar a Nota Tomador!" 
              : "Houve um problema ao salvar o DAPS!";

            if (error.response) {
              const errors = Array.isArray(error.response.data)
                ? error.response.data
                : [error.response.data];

              errors.forEach(err => {
                this.$toast.add({
                  severity: "error",
                  summary: "Erro",
                  detail: err,
                  life: 5000,
                });
              });
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Erro",
                detail: errorMessage,
                life: 5000,
              });
            }

            this.processando(false);
          }
        ) 
        .then(() => {
          this.processando(false);
        });
    },
      
      getBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
      },

    cancelarDaps() {
      this.processando(true);
      this.erros = [];
      DapsService.cancelar(this.daps.id)
        .then(
          (data) => {
            this.daps = data.data;

            this.$toast.add({
              severity: "success",
              summary: "Sucesso",
              detail: (this.notaTomador ? "Nota Tomador cancelada com sucesso!" : "O DAPS foi Cancelado!"),
              life: 4000,
            });
          },
          (error) => {
            this.erros.push(...error.response.data);
            console.log(error.response);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },

    validarAliquota() {
      if (this.desabilitarAliquota) {
        return;
      }
      if (this.daps && this.selectedRegimeTributacao && this.selectedServico) {
        this.processando(true);
        DapsService.validarAliquotaV2(
          this.daps.aliquota,
          this.selectedRegimeTributacao.key,
          this.selectedServico.valorAliquota,
          this.selectedTipoRecolhimento.key,
          (this.daps.idBeneficio && (this.daps.tipoBeneficio === 'A' || this.daps.tipoBeneficio === 'F') ? this.daps.idBeneficio : null)
        )
          .then(
            (data) => {
              if (data.data.validado) {
                console.log("Alíquota válida!");
              } else {
                this.$toast.add({
                  severity: "warn",
                  summary: "Alíquota inválida!",
                  detail: data.data.mensagem,
                  life: 4000,
                });
                this.daps.aliquota = 0;
              }
            },
            (error) => {
              console.log(error);

              this.$toast.add({
                severity: "error",
                summary: "Erro",
                detail: "Erro durante a validação!",
                life: 4000,
              });
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },

    selecionarTipoEmissao() {
      this.selectedPessoa = "";
      this.validarTela();
    },

    validarTipoTomador(){
      if(this.selectedTipoTomador.key === 'N' && (this.selectedTipoEmissao && this.selectedTipoEmissao.key === 'P')){//emissão do tipo prestador com tomador não identificado não pode ter retenção
        this.tiposRecolhimento = [{ name: "Não Retido", key: "N" }];
        this.selectedTipoRecolhimento = this.tiposRecolhimento[0];
      }
    },
    async validarTela() {
      this.processando(true);
      console.log("Validar tela");
      this.ajusteIss = 'NORMAL';
      this.percBeneficioBaseCalculo = null;
      this.aplicarDeducaoAutomatica = 'N';  
      var servico = "";
      var regime = "";
      var tpRecolhimento = "";
      if (this.selectedServico && this.selectedServico.id) {
        servico = this.selectedServico.id;
      }
      if (this.selectedRegimeTributacao) {
        regime = this.selectedRegimeTributacao.key;
        console.log("regimeTrib " + this.selectedRegimeTributacao.key);
      }
      if (this.selectedTipoRecolhimento) {
        tpRecolhimento = this.selectedTipoRecolhimento.key;
        console.log("tpRecolhimento " + this.selectedTipoRecolhimento.key);
      }

      let dataEmissao = this.daps && this.daps.dataFatoGerador ? this.moment(this.daps.dataFatoGerador).format(
          "YYYY-MM-DD"
        ) : null;

      DapsService.validarTelaV3(
        this.selectedTipoEmissao ? this.selectedTipoEmissao.key : '',
        servico,
        tpRecolhimento,
        regime,
        (this.selectedPessoa ? this.selectedPessoa.id : null),
        dataEmissao
      )
        .then((data) => {
          console.log(data.data);
          this.tiposEmissao = data.data.tiposEmissao;


          if(this.tiposEmissao != null && this.tiposEmissao.length === 1){
            this.selectedTipoEmissao = this.tiposEmissao[0];
          }

          if(this.tiposEmissao != null && this.tiposEmissao.length === 2 && this.selectedTipoEmissao === null){
            this.contribuinteCadastro = this.currentUser.contribuinte;
            if(this.contribuinteCadastro && this.contribuinteCadastro.idContribuinteTipo && this.contribuinteCadastro.idContribuinteTipo === this.currentUser.configuracao.idContrTipoEventual){
              this.selectedTipoEmissao = this.tiposEmissao[0];
            }
          }

          this.tiposRecolhimento = data.data.tiposRecolhimento;
          console.log('VALIDANDO ALIQUOTA');    
          console.log(data.data.aliquota);  
          if (data.data.aliquota != null) {
            this.daps.aliquota = data.data.aliquota;
          }
          if (data.data.idBeneficio != null) {
            this.daps.idBeneficio = data.data.idBeneficio;
            this.daps.tipoBeneficio = data.data.tipoBeneficio;
          }

          if (
            this.selectedTipoRecolhimento.key == "R" &&
            data.data.idMunicipioPrestacao
          ) {
            this.selectedMunicPrestacao = data.data.idMunicipioPrestacao;
          }

          

          //data.data.desabilitarLocalPrestacao
          this.desabilitarAliquota = data.data.desabilitarAliquota;
          this.desabilitarDeducao = data.data.desabilitarDeducao;
          this.percBeneficioBaseCalculo = data.data.percBeneficioBaseCalculo;
          this.aplicarDeducaoAutomatica = data.data.aplicarDeducaoAutomatica
        })
        .then(() => {
          this.validarTipoTomador();
          this.validarAliquota();
          this.processando(false);
        });
    },

    atualizarDadosPessoaSelecionada() {
      
      if (
        this.selectedPessoa &&
        this.selectedPessoa.id
      ) {
        this.processando(true);
        NfsPessoaService.atualizaDadosPessoaValidacao(this.selectedPessoa.id).then(
          (data) => {
            console.log(data);
            this.selectedPessoa = data.data;
            DapsService.validarPrestadorValido(this.daps.idCliente, this.selectedTipoTomador.key, this.selectedTipoEmissao ? this.selectedTipoEmissao.key : '', this.selectedPessoa.id, this.currentUser.contribuinte.documento).then(
              (responseValidar) => {
                console.log(responseValidar);
                let retorno  = responseValidar.data;
                console.log(retorno);
                if(retorno === 'D'){
                  this.selectedPessoa = null;
                  let tipoContr = (this.selectedTipoEmissao && this.selectedTipoEmissao.key == "T" ? "Prestador" : "Tomador");
                  this.$root.$emit("alert:warn", "Não é possível selecionar o própio contribuinte como "+tipoContr+"!");
                }else if(retorno === 'N'){
                  this.selectedPessoa = null;
                  this.$root.$emit("alert:warn", "Prestador inscrito no cadastro Econômico do município, não sera possível utiliza-lo para esta emissão!");
                }
              }
            ).then(() => {
            this.processando(false);
            });
          },
          (error) => {
            if(error.response.data){
              this.$root.$emit("alert:warn", error.response.data);
            }else{
              this.$root.$emit("alert:warn", "Não foi possível selecionar o contribuinte!");
            }
            this.selectedPessoa = null;
          }
        ) 
      }
    },

    validarLocalidadeSelecionada() {
      if (this.selectedMunicPrestacao && this.selectedMunicPrestacao.id) {
        if (this.selectedMunicPrestacao && this.selectedMunicPrestacao.codigoIbge === 9999999 && this.currentUser.contribuinteConfig.idBolTomadorExterior != 'S') {
          this.selectedMunicPrestacao = null;
          this.$root.$emit("alert:warn", "O prestador não pode selecionar local de prestação estrangeiro!");
          return;
        }

        this.processando(true);
        
        DapsService.validarLocalidade(this.daps.idCliente, this.selectedMunicPrestacao.id, this.selectedTipoRecolhimento.key).then(
          (responseValidar) => {
            console.log(responseValidar);
            let retorno  = responseValidar.data;
            console.log("RETORNO LOCALIDADE: "+retorno);
            if(retorno === 'N'){
              this.selectedMunicPrestacao = null;
              this.$root.$emit("alert:warn", "Não será possível a emissão para fora do município sede!");
            }
          }
        ).then(() => {
          this.processando(false);
        });
      }
    },

    imprimirDaps() {
      this.processando(true);

      let rel = (this.notaTomador ? "NotaFiscalTomador" : "NotaFiscalAuxiliar");

      ReportService.imprimir(rel, [
        {
          param: "where",
          string: " and nota.id = '" + this.daps.id + "' ",
        },
      ])
        .then(
          () => {},
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao Imprimir!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },

    novoDaps() {
      this.erros = [];
      this.limparDadosDaps();

      document.getElementById("topo").scrollIntoView({
        behavior: "smooth",
      });
    },

    novoTomador() {
      this.$root.$emit("notaFiscal:novoTomadorDaps");
    },

    editarTomador() {
      this.$root.$emit("notaFiscal:editarTomador");
    },

    removerTomador() {
      this.$root.$emit("notaFiscal:removerTomador", this.selectedPessoa);
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },
    roundToTwo(num) {
      return +(Math.round(num + "e+2") + "e-2");
    },
    openMessageSimoes(){
      if(this.currentUser.usuario.idCliente == "19533831040781681800D2584C905F8A"){
        this.showMessageSimoes = true;
      }else{
        this.showMessageSimoes = false;
      }
    },
    roundHalfUp(valor, casas = 2) {
      const fator = Math.pow(10, casas);
      const extra = Math.pow(10, casas + 1); 
      
      const ajustado = Math.floor(valor * extra + 0.0000001); 
      
      const digitoExtra = ajustado % 10;  
      let resultado = Math.floor(ajustado / 10); 
      
      if (digitoExtra >= 5) {
        resultado += 1; 
      }
      
      return resultado / fator;
    },
    validarDescontoAutomatico(){
      if(this.percBeneficioBaseCalculo && (this.aplicarDeducaoAutomatica && this.aplicarDeducaoAutomatica === 'S')  && this.percBeneficioBaseCalculo && this.percBeneficioBaseCalculo > 0
      && this.daps.valorServico && this.daps.valorServico > 0){
          let desconto = (this.daps.valorServico * this.percBeneficioBaseCalculo / 100.0)
          this.daps.valorDesconto = desconto;
      }
    },

    aumentarIss() {
      if (!this.isCompensacaoIssAtiva) return;

      if (this.ajusteIss === 'MAIS') return;
      this.ajusteIss = 'MAIS';
    },

    diminuirIss() {
      if (!this.isCompensacaoIssAtiva) return;

      if (this.ajusteIss === 'MENOS') return;
      this.ajusteIss = 'MENOS';
    },

    resetarIss() {
      if (!this.isCompensacaoIssAtiva) return;

      this.ajusteIss = 'NORMAL';
    }
    
  },

  computed: {
    exibirBotao() {
      const botoes = {
        novo: false,
        gravar: false,
        cancelar: false,
        imprimir: false,
      };

      botoes.novo = true;
      botoes.gravar = this.daps.id == null || this.daps.id == "";
      botoes.cancelar =
        this.daps.id != null &&
        this.daps.id != "" &&
        this.daps.dataVigenciaFinal == null;
      botoes.imprimir = this.daps.id != null && this.daps.id != "";

      return botoes;
    },

    desabilitarCampoTipoNota() {
      return (this.currentUser && this.currentUser.usuario && (this.currentUser.usuario.idCliente == "19533831040781681800D2584C905F8A" || this.currentUser.usuario.idCliente == "82a72051-c35b-4af3-abe0-93ce82e84b49") ? true : false);
    },

    desabilitarEdicaoMunicipioPrestacao() {
      return this.selectedTipoRecolhimento.key == "R" ? true : false;
    },

    desabilitarCampoAliquota() {
      return this.desabilitarAliquota ? true : false;
    },

    desabilitarCampoDeducao() {
      return this.desabilitarDeducao ? true : false;
    },

    desabilitarBotaoNovoTomador() {
      return this.selectedTipoTomador.key == "N" || this.desabilitarEdicaoCampos
        ? true
        : false;
    },

    desabilitarBotaoEdicaoTomador() {
      return !this.selectedPessoa || this.desabilitarEdicaoCampos
        ? true
        : false;
    },

    desabilitarBotaoRemoverTomador() {
      return !this.selectedPessoa || this.desabilitarEdicaoCampos
        ? true
        : false;
    },

    baseCalculo: {
      get() {
        return this.roundToTwo(
          this.daps.valorServico - this.daps.valorDesconto
        );
      },
      set(val) {
        this.valorBaseCalculo = val;
      },
    },

    valorIss: {
      get() {
        //solicitada alteracao pra que o iss seja arredondado pra cima
        //return this.roundToTwo((this.baseCalculo * this.daps.aliquota) / 100);
        //Processo 075743/2025
        const resultado = this.roundHalfUp(((this.baseCalculo * this.daps.aliquota) / 100),2);
        return resultado;
      },
      set(val) {
        this.valorRetencao = val;
      },
    },

    valorIssFinal() {
      let valor = this.valorIss;

      if (!this.isCompensacaoIssAtiva) {
        return valor;
      }

      if (this.ajusteIss === 'MAIS') {
        return this.roundToTwo(valor + 0.01);
      }

      if (this.ajusteIss === 'MENOS') {
        return this.roundToTwo(valor - 0.01);
      }

      return valor;
    },

    isCompensacaoIssAtiva() {
      return this.currentUser 
        && this.currentUser.configuracao 
        && this.currentUser.configuracao.idBolCompensaIssDaps === 'S';
    },

    desabilitarEdicaoCampos() {
      return this.daps && this.daps.id ? true : false;
    },
  },

  validators: {
    // "selectedPessoa.id": function(value) {
    //  return Validator.value(value).required("Necessário informar um Tomador");
    // }
  },
};
</script>

<style scoped>
.p-inputtext {
  text-align: right;
}
.alinhar-texto {
  text-align: left;
}
.p-inputtext:disabled {
  color: #a6a6a6;
  border-color: #a6a6a6;
}
textarea {
  width: 100%;
  border-radius: 12px;
}

button.iss-original{
  margin-right: 6px;
}
</style>